// ── Capital letters in a natural person's name (Calem 2026-09-25) ───────────────────────────────
// Frontend mirror of normalisePersonNamePart in server/src/services/clientName.ts — keep the two in
// step. The server applies it when an individual is saved; the First / Middle / Last boxes apply it
// as they lose focus, so the correction is on screen before Save is pressed.
//   "SMITH" → "Smith" · "smith" → "Smith" · "O'NEIL" → "O'Neil" · "McDonald" stays as typed ·
//   Thai stays as typed · "j.r." → "J.R." · "III" stays as typed.
const CASED_WORD = /([\p{Lu}\p{Ll}\p{Lt}])([\p{Lu}\p{Ll}\p{Lt}\p{M}]*)/gu;
const NUMERAL_SUFFIX = /^(II|III|IV)$/;

export function normalisePersonNamePart(part: string): string {
  return part.replace(CASED_WORD, (w: string, head: string, rest: string) =>
    NUMERAL_SUFFIX.test(w) ? w : head.toUpperCase() + (rest === rest.toUpperCase() ? rest.toLowerCase() : rest));
}
